export default "//cloud.imgsmail.ru/cloud.mail.ru/182280/img/build/errors/error-bad-browser.png";